import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function SpeedLow({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M10.5578 11.59L5.4678 6.49997M3.7878 9.30997C2.0878 13.03 3.1278 17.43 6.3278 19.99M8.2878 4.80997C9.4478 4.26997 10.7078 3.99997 11.9778 3.98997L11.9788 3.98897C16.9488 3.97897 20.9788 8.00897 20.9888 12.979C20.9988 15.699 19.7588 18.269 17.6488 19.979M11.9678 10.99C12.4982 10.99 13.0069 11.2007 13.382 11.5758C13.7571 11.9508 13.9678 12.4595 13.9678 12.99C13.9678 13.5204 13.7571 14.0291 13.382 14.4042C13.0069 14.7793 12.4982 14.99 11.9678 14.99C11.4374 14.99 10.9287 14.7793 10.5536 14.4042C10.1785 14.0291 9.9678 13.5204 9.9678 12.99C9.9678 12.4595 10.1785 11.9508 10.5536 11.5758C10.9287 11.2007 11.4374 10.99 11.9678 10.99Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default SpeedLow;